<template>
  <BoardView id="PageBatch" :title="$t('title', [pageBatch.id])" wrap="lg">
    <div class="batchTabs">
      <Tab
        v-for="{ key, label } in tabs"
        :key="label"
        :isActive="tabActiveKey === key"
        @click="tabActiveKey = key">
        {{ label }}
      </Tab>
    </div>
    <Field
      :aria-label="$t('search')"
      :placeholder="$t('search')"
      :value.sync="search" />
    <PageList
      :pages="pages" />
  </BoardView>
</template>

<script>
import { actions, getters } from '@utils'
import BoardSingle from '@mixins/BoardSingle'
import PageList from './components/PageList'
import Tab from '@components/Tab'
import { propEq } from 'rambda'

export default {
  mixins: [BoardSingle('pageBatch')],
  components: {
    PageList,
    Tab,
  },
  data() {
    return {
      search: null,
      tabActiveKey: 'ALL',
      tabs: [
        {
          key: 'ALL',
          label: this.$t('tabs.ALL'),
          query: {},
        },
        {
          key: 'FAILED',
          label: this.$t('tabs.FAILED'),
          query: {
            status: { $like: '_FAIL' },
          },
        },
      ],
    }
  },
  computed: {
    pageQuery() {
      const tabActiveQuery = this.tabs
        .find(propEq('key', this.tabActiveKey))
        .query

      return {
        pageBatchId: this.pageBatch.id,
        ...tabActiveQuery,
        ...(this.search ? { url: { $ilike: this.search } } : {}),
      }
    },
    pages() {
      return this.query('page', this.pageQuery)
    },
    ...getters(),
  },
  methods: actions('FETCH_PAGE'),
  watch: {
    pageQuery: {
      immediate: true,
      async handler(pageQuery) {
        await this.FETCH_PAGE(pageQuery)
      },
    },
  },
}
</script>

<style lang="scss">
#PageBatch {
  .batchTabs {
    margin-bottom: 1rem;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Batch #{0}",
    "search": "Search",
    "tabs": {
      "ALL": "All",
      "FAILED": "Failed"
    }
  }
}
</i18n>
